import { makeStyles } from "@material-ui/core";
import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Dialog,
  Typography,
  circularProgressClasses,
} from "@mui/material";

interface SubmitLoaderProps {
  open: boolean;
  title?: string;
}

export default ({ open, title }: SubmitLoaderProps) => {
  const classes = useStyles();
  return (
    <>
      {/* <Dialog open={open} className={`${classes.dialog} submitLoader`}> */}
      {open && (
        <Box className={classes.container}>
          <Box className={classes.root}>
            <ProgressBar />
            <Typography className={classes.title}>
              {title ?? "This process may take up to 2 minutes"}
            </Typography>
          </Box>
        </Box>
      )}
      {/* </Dialog> */}
      <style>{`
            .submitLoader .MuiDialog-paper {
                max-width: 100%;
                border-radius: 24px !important
               
            }
            @media(max-width:400px){
                .submitLoader .MuiDialog-paper {
                    max-width: 100%;
                    border-radius: 24px !important;    
                    // min-height:22vh ;
                }
            }
        `}</style>
    </>
  );
};

const ProgressBar = (props: CircularProgressProps) => {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.secondary.main,
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: "white !important",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  dialog: {
    maxWidth: "100%",
    overflow: "hidden",
  },
  container: {
    width: "100%",
    height: "100%",
    position: "fixed",
    background: "rgba(0, 0, 0, 0.5)",
    zIndex: "100",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    top: 0,
    left: 0,
  },
  root: {
    boxSizing: "border-box",
    // width: "90%",
    padding: 32,
    backgroundColor: "#4C4C4C",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
    borderRadius: "20px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: 26,
      gap: 20,
    },
  },
  title: {
    fontSize: "20px !important",
    color: "#fff",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px !important",
    },
  },
}));
